/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';

import { AITopicsByPerson, type AITopicsByPersonProps } from '../ai-topics/ai-topics-by-person';

const styles = cssMap({
	root: {
		// marginTop: token('space.negative.200'), // negative margins to pull topics card into place
		// marginBottom: token('space.050'),
	},
});

export const KnowledgeCardsTopics: (props: AITopicsByPersonProps) => JSX.Element = (
	props: AITopicsByPersonProps,
) => {
	return (
		<Box xcss={styles.root}>
			<AITopicsByPerson {...props} />
		</Box>
	);
};
